import Service from "./Service";
const baseurl = '/api/historial-anticoncepcional';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showByIdUser(id) {
        return Service.get(`${baseurl}/show-by-idUser/${id}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByHc(id) {
        return Service.get(`${baseurl}/show-by-hc/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}